// Page: usage  (utility-usage / credentials + bill-upload step)
//
// Ported from the inline <script> in
//   Enrollment_modules/usage/form.module/module.html (lines 328–2551).
//
// MECHANICAL / FAITHFUL PORT — runtime behaviour is preserved. Deliberate changes:
//   1. Selectors scoped to the render wrapper `<div class="lgsiayeu-main">` are now
//      scoped to `root` (the element carrying data-ea-module) via q/qi/qa. Kept
//      document-scoped, exactly as the original: `document.querySelector('body')`,
//      `document.querySelectorAll('button')`/`('a')`; the loader/overlay lookups
//      `getElementById('myUsageLoader')`/`('MUloaderOverlay')` (via `di`); and the
//      cross-widget `.page1lmileftright_myusage #goback-personal-info` (sibling
//      widget, NOT inside lgsiayeu-main) via `dq`.
//   2. `_hcms/api/*` fetches and same-origin redirects are ROOT-RELATIVE (core/api
//      `apiUrl`, or plain "/x") instead of hardcoding https://enrollment.nautilussolar.com.
//   3. HubDB read URLs are built with core/hubdb `hubdbRowsUrl` (keys `uanConfig`,
//      `utilityAvailability`) instead of inline literals.
//   4. Two EXTERNAL non-portal hosts have NO __ENV__ key and are kept as literal
//      absolute URLs (faithful — inventing an env key is scope creep): the AWS
//      file-upload service (uploadFileToServer) and the Hansen utility-validation
//      service (validateUtility, note it is `http://`). Flagged, not rewritten.
//   5. localStorage goes through core/storage. Keys outside the StorageKey union
//      use raw*: `UanNumber`, `isWeBackFromTYP`, `is_enrolled_for_bayou`, `rp`.
//   6. The formerly-inline onclick/ondrop/ondragover handlers (toggleContent,
//      triggerFilePicker, triggerFileInput, dragOverHandler, dropHandler,
//      removeImageOpenPopup, removeCurrentImage, removeImageClosePopup) are stripped
//      from the markup and re-bound root-scoped via addEventListener at the end of
//      init — no page function leaks onto `window` (matches modules/savings-intro.ts).
//   7. `crypt` is the ambient global (global.d.ts); the crypto-js provider + the
//      `var crypt` glue block stay in module.html untouched.
//   8. `// NOTE:` marks preserved latent bugs kept compilable via a cast (the bare
//      `#utilityAccountNo` id that only ever exists as indexed variants; the
//      `document.getElementsById` typo; `'/'.source`). No BUGFIX was needed.
//
// Dynamic ES5 patterns (vars reassigned across types, HubDB rows, DataTransfer/File/
// IndexedDB shapes) are typed `any` to keep the port mechanical.
//
// External globals (crypt, Swiper, pdfjsLib) are declared ambiently in global.d.ts.

import { apiUrl } from "../../core/api"
import { hubdbRowsUrl } from "../../core/hubdb"
import * as storage from "../../core/storage"

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/usage/usage.ts","init",[root,_config],["root","_config"]);
  // ─── Scoped DOM helpers ──────────────────────────────────────────────────────
  const q = (sel: string) => root.querySelector(sel) as HTMLElement
  const qi = (sel: string) => root.querySelector(sel) as HTMLInputElement
  const qa = (sel: string) => root.querySelectorAll(sel)
  const di = (id: string) => document.getElementById(id) as HTMLElement
  const dq = (sel: string) => document.querySelector(sel) as HTMLElement

  // ─── Shared state (was module-scoped / hoisted in the inline script) ──────────
  let responseFromAPI: any = ""
  const stat = storage.get("FarmStateAbbreviation")

  let firstId: any
  let bayouAccountNo: any
  void bayouAccountNo
  let selectRadioValue: any
  let isChecked = false
  const storedDisplayElementList: any = JSON.parse(storage.get("usageDisplayelementList") ?? "null")
  const storedRequireElementList: any = JSON.parse(storage.get("usagerequireElementList") ?? "null")
  void storedRequireElementList
  const shouldValidate = false
  void shouldValidate

  // utilityNumberRegexFromSessionTable
  const UtilityAccountNumberRegexErrorMsg: any[] = []
  const utRgxNumber: any[] = []
  let utRgxNumberInput: any
  let UtilityAccountNumberRegexErrorMsgInput: any
  let uanSingleValue = ""
  let uanSingleErrorMsgField: any
  let clickutilityAccountInputs: any
  const allAccountNumbers: any[] = []
  const uanAllLabels: any[] = []
  const uanFieldDefault: any[] = []
  const uanFieldDisplayarray: any[] = []
  const uanFieldIntDesArray: any[] = []

  let globPass: any
  let verifyidenty: any
  let enrollmentSessionID: any
  const utilityIdd = storage.get("utility_id")

  const isInvalidFileType = false
  void isInvalidFileType
  const isExceededSize = false
  void isExceededSize
  const listOfFiles: any[] = []
  let swiper: any
  const uploadedurl: any[] = []
  void uploadedurl

  const limit = 1000
  let offset = 0
  let allRows: any[] = []

  let isWeBackFromTYP = false

  let db: any
  const is_enrolled_for_bayou = storage.rawGet("is_enrolled_for_bayou")

  // ─── Get saved data ────────────────────────────────────────────────────────────
  async function GetDataFromDealRecord(): Promise<void> {
__ea_trace("modules/usage/usage.ts","GetDataFromDealRecord",[],[]);
    // var email = localStorage.getItem("userEmail");
    const dealId = storage.get("dealId")
    let catchdata: any = ""
    try {
      const data = { deal_id: dealId }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      if (dataa.message === "No User Found") {
      } else if (dataa.message === "User Found") {
        const userName = dataa.userValue.properties.utility_username
        let utilityPass: any = dataa.userValue.properties.utility_password
        const utilityAccountNumber = dataa.userValue.properties.utility_account_number
        const doYouHaveAccount = dataa.userValue.properties.do_you_have_an_account_with_utility_service_provider
        const dealStage = dataa.userValue.properties.dealstage
        void dealStage
        if (isWeBackFromTYP !== true) {
          if (doYouHaveAccount === "Yes") {
            qi("#skipThisForNowAndGetInTouch").checked = false
            qi("#iHaveOnlineAccount").checked = true
          } else if (doYouHaveAccount === "No") {
            qi("#iHaveOnlineAccount").checked = false
            qi("#skipThisForNowAndGetInTouch").checked = true
          }
        }
        if (userName != null) {
          qi("#UtilityUsername").value = userName
        }
        if (utilityPass != null) {
          utilityPass = crypt.decrypt(utilityPass)
          qi("#UtilityPassword").value = utilityPass
        }
        if (utilityAccountNumber != null) {
          // NOTE: bare `#utilityAccountNo` never exists (only indexed variants
          // `#utilityAccountNo0`…); null.value throws here — preserved.
          qi("#utilityAccountNo").value = utilityAccountNumber
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }

  // If user is not logged in redirect them to the login page.
  function getEmail(): boolean | undefined {
__ea_trace("modules/usage/usage.ts","getEmail",[],[]);
    const storedEmail = storage.get("userEmail")
    if (!storedEmail) {
      window.location.href = "/"
      return false
    }
  }

  function triggerFilePicker(): void {
__ea_trace("modules/usage/usage.ts","triggerFilePicker",[],[]);
    // q('#mobileCamera input[type="file"]').click();
    q("#file-error-message").innerHTML = ""
    q("#fileInput").click()
  }

  function ShowHide(): void {
__ea_trace("modules/usage/usage.ts","ShowHide",[],[]);
    toggleElementVisibility("haveOnlineAccountMainDiv", "UTILITY CREDENTIALS DISPLAY")
    // toggleElementVisibility("iDoNotHaveOnlineAcc", "CREATE UTILITY ACCOUNT DISPLAY");
    toggleElementVisibility("SkipThisFornNow", "SKIP FOR NOW DISPLAY")
    toggleElementVisibility("utility", "UTILITY ACCOUNT NUMBER DISPLAY")
    toggleElementVisibility("upload-picture-main", "BILL UPLOAD DISPLAY")
  }
  function toggleElementVisibility(elementId: string, nameFromTable: string): void {
__ea_trace("modules/usage/usage.ts","toggleElementVisibility",[elementId,nameFromTable],["elementId","nameFromTable"]);
    const element = q(`#${elementId}`)
    if (storedDisplayElementList.includes(nameFromTable)) {
      element.style.display = "block"
    } else {
      element.style.display = "none"
    }
  }

  function SetRequire(): void {
__ea_trace("modules/usage/usage.ts","SetRequire",[],[]);
    // UTILITY CREDENTIALS REQUIRED / CREATE UTILITY ACCOUNT REQUIRED /
    // SKIP FOR NOW REQUIRED / UTILITY ACCOUNT NUMBER REQUIRED / BILL UPLOAD REQUIRED
    if (storedRequireElementList.includes("UTILITY CREDENTIALS REQUIRED")) {
      // (original left this branch empty)
    }
  }
  void SetRequire

  // ─── Loader ─────────────────────────────────────────────────────────────────
  function pageFoundOpenLoader(): void {
__ea_trace("modules/usage/usage.ts","pageFoundOpenLoader",[],[]);
    const loader = di("myUsageLoader")
    const body = document.querySelector("body")
    void body
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    di("MUloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/usage/usage.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/usage/usage.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as unknown as HTMLButtonElement).disabled = true
    })
  }
  function pageFoundCloseLoader(): void {
__ea_trace("modules/usage/usage.ts","pageFoundCloseLoader",[],[]);
    const loader = di("myUsageLoader")
    const body = document.querySelector("body")
    void body
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    di("MUloaderOverlay").style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/usage/usage.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/usage/usage.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as unknown as HTMLButtonElement).disabled = false
    })
  }

  // ─── UAN config table ──────────────────────────────────────────────────────────
  async function getDataFromUANConfigTable(UANutilityIdd: any): Promise<void> {
__ea_trace("modules/usage/usage.ts","getDataFromUANConfigTable",[UANutilityIdd],["UANutilityIdd"]);
    void UANutilityIdd
    const exampleUtilityId = storage.get("utility_id")
    const stateForUANConfig = storage.get("stateForLMIConfig")
    const utilityNameForUANConfig = storage.get("utility_Name")
    const hubDBEndpointUANC = hubdbRowsUrl("uanConfig", {
      orderBy: "uan_field_display_sequence",
      utility_id: String(exampleUtilityId),
      state_name: String(stateForUANConfig),
    })
    const responseUANC = await fetch(hubDBEndpointUANC, { method: "GET" })
    const dataUANC = await responseUANC.json()
    const rowsUANC = dataUANC.objects
    if (rowsUANC.length >= 1) {
      rowsUANC.forEach((element: any, index: number) => {
__ea_trace("modules/usage/usage.ts","(anon)",[element,index],["element","index"]);
        const uanFieldDisplay = element.values["4"].name
        if (uanFieldDisplay === "Yes") {
          uanFieldDefault[index] = element.values["5"]
          uanFieldDisplayarray[index] = element.values["4"].name
          const uanFieldDisSeq = element.values["6"]
          void uanFieldDisSeq
          const uanFieldLable = element.values["8"]
          uanAllLabels[index] = uanFieldLable
          const uanFieldIntDes = element.values["8"]
          uanFieldIntDesArray[index] = element.values["8"]
          const uanFieldHlpTxtHeading = element.values["9"]
          const uanFieldHlpTxtInst = element.values["10"]
          utRgxNumber[index] = element.values["11"]
          UtilityAccountNumberRegexErrorMsg[index] = element.values["12"]
          const uanFieldHelpImgTxt = element.values["13"]
          let uanHelpImg = ""
          if (element.values["14"] !== undefined) {
            uanHelpImg = element.values["14"].url
          }
          const uanConctSeq = element.values["15"]
          void uanConctSeq
          const appendField =
            '<div class="utilityAccountNoWrapper" id="utilityAccountNoWrapper' +
            index +
            '"><label id="MUuaclabel' +
            index +
            '"><span id="utilityAccountNoLabel' +
            index +
            '">' +
            uanFieldLable +
            '</span></label><input type="text" key="' +
            index +
            '" placeholder="' +
            uanFieldIntDes +
            '" class="utilityAccountNo" id="utilityAccountNo' +
            index +
            '" /><div id="utility_acc_num_error_message' +
            index +
            '" class="error-message"></div><p id="utilityAccInsTitle' +
            index +
            '">' +
            uanFieldHlpTxtHeading +
            '</p><p><span class="utilityAccIns' +
            index +
            '">' +
            uanFieldHlpTxtInst +
            '</span><br><br><a href="' +
            uanHelpImg +
            '" id="utilityBillImageAcNo' +
            index +
            '" target="_blank">' +
            uanFieldHelpImgTxt +
            ' <span class="utilityName' +
            index +
            '">' +
            utilityNameForUANConfig +
            "</span>.</a></p></div>"
          const existingContent = q(".utilityPictureIpiaap3Wrapper #utility").innerHTML
          const appendedContent = existingContent + appendField
          q(".utilityPictureIpiaap3Wrapper #utility").innerHTML = appendedContent
          // getUtilityNumberRegex(uanFieldReg);
        } else if (uanFieldDisplay === "No") {
          uanFieldDefault[index] = element.values["5"]
          uanFieldDisplayarray[index] = element.values["4"].name
          uanFieldIntDesArray[index] = element.values["8"]
        }
      })
      uanSingleErrorMsgField = q("#utility_acc_num_error_message0")
      if (uanSingleErrorMsgField == null || uanSingleErrorMsgField === "null") {
        uanSingleErrorMsgField = q("#utility_acc_num_error_message1")
      }
      if (uanSingleErrorMsgField == null || uanSingleErrorMsgField === "null") {
        uanSingleErrorMsgField = q("#utility_acc_num_error_message2")
      }

      clickutilityAccountInputs = qa("#utility .utilityAccountNoWrapper .utilityAccountNo")
      const utilityAccountInputs = qa("#utility .utilityAccountNoWrapper .utilityAccountNo")
      utilityAccountInputs.forEach((input: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[input],["input"]);
        input.addEventListener("input", (event: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[event],["event"]);
          const keyAttributeValue = input.getAttribute("key")
          const inputValue = event.target.value
          uanSingleValue = inputValue
          utRgxNumberInput = utRgxNumber[keyAttributeValue]
          UtilityAccountNumberRegexErrorMsgInput = UtilityAccountNumberRegexErrorMsg[keyAttributeValue]
          uanSingleErrorMsgField = q(`#utility_acc_num_error_message${keyAttributeValue}`)
          validateAccountNumber(null)
        })
      })
    }
  }

  // Get all elements with the class .utilityAccountNo
  function validateAccountNumberold(): string | null {
__ea_trace("modules/usage/usage.ts","validateAccountNumberold",[],[]);
    // NOTE: bare `#utilityAccountNo` never exists (only indexed variants) — dead code.
    const utilityAccountNo = qi("#utilityAccountNo").value.trim()
    function extractNumbersFromRegex(regex: any): number[] {
__ea_trace("modules/usage/usage.ts","extractNumbersFromRegex",[regex],["regex"]);
      const matches = regex.match(/\d+/g)
      const numbers = matches.map((match: any) => parseInt(match, 10))
      return numbers
    }
    // NOTE: `'/'.source` is undefined at runtime (string has no `source`) —
    // preserved via cast; this is unreachable dead code.
    const extractedNumbers = extractNumbersFromRegex(`/${utRgxNumber}${("/" as any).source}`)
    const isValid = extractedNumbers.includes(utilityAccountNo.length)
    const errorMessage = q("#utility_acc_num_error_message")
    if (utilityAccountNo !== "") {
      if (!isValid) {
        errorMessage.textContent = "Please enter a valid " + JSON.stringify(extractedNumbers) + " digit account number."
        return "error"
      } else {
        errorMessage.textContent = ""
        return null
      }
    } else {
      errorMessage.textContent = "Please enter account number."
      return "error"
    }
  }
  void validateAccountNumberold

  function validateAccountNumber(abc: any): string | null {
__ea_trace("modules/usage/usage.ts","validateAccountNumber",[abc],["abc"]);
    if (abc != null && abc !== "") {
      uanSingleErrorMsgField.textContent = ""
      return null
    } else {
      if (uanSingleValue !== "") {
        const regex = new RegExp(utRgxNumberInput)
        if (regex.test(uanSingleValue)) {
          uanSingleErrorMsgField.textContent = ""
          return null
        } else {
          if (UtilityAccountNumberRegexErrorMsgInput == null || UtilityAccountNumberRegexErrorMsgInput === "") {
            uanSingleErrorMsgField.textContent = "Please enter a valid account number."
          } else {
            uanSingleErrorMsgField.textContent = UtilityAccountNumberRegexErrorMsgInput
          }
          return "error"
        }
      } else {
        if (uanFieldDisplayarray.length === 0) {
          return null
        } else {
          uanSingleErrorMsgField.textContent = "Please enter account number."
          return "error"
        }
      }
    }
  }

  function checkAllUANFieldOnClick(): string | boolean {
__ea_trace("modules/usage/usage.ts","checkAllUANFieldOnClick",[],[]);
    let inputValueBoolean = false
    clickutilityAccountInputs.forEach((input: any, index: number) => {
__ea_trace("modules/usage/usage.ts","(anon)",[input,index],["input","index"]);
      const inputValue = input.value
      if (inputValue) {
        allAccountNumbers[index] = inputValue
      } else {
        inputValueBoolean = true
        const keyAttributeValue = input.getAttribute("key")
        q(`#utility_acc_num_error_message${keyAttributeValue}`).textContent = "Please enter account number."
      }
    })

    if (inputValueBoolean) {
      return "error"
    } else {
      return true
    }
  }

  function getAccountNumberErrorifExist(): string | null {
__ea_trace("modules/usage/usage.ts","getAccountNumberErrorifExist",[],[]);
    const val = validateAccountNumber(firstId)
    const val2 = checkAllUANFieldOnClick()
    if (val === "error" || val2 === "error") {
      return "error"
    } else {
      return null
    }
  }

  function validateHaveonline(): string | null {
__ea_trace("modules/usage/usage.ts","validateHaveonline",[],[]);
    const radioButtons = qa('[name="myInfoRadio"]')
    for (let i = 0; i < radioButtons.length; i++) {
      if ((radioButtons[i] as HTMLInputElement).checked) {
        selectRadioValue = (radioButtons[i] as HTMLInputElement).value
        isChecked = true
        break
      }
    }

    if (!isChecked) {
      q("#radioNull-error-message").innerHTML = "Please select an option."
      return "error"
    } else {
      if (selectRadioValue === "haveOnline") {
        const radioerrorList = [validateUsername(), validatePassword()]
        if (!radioerrorList.includes("error")) {
          // validateUtility();
          return null
        } else {
          q("#verification-error-message").innerHTML = "please fix the errors before submitting form"
          return "error"
        }
      } else {
        q("#radioNull-error-message").innerHTML = ""
        return null
      }
    }
  }

  function validateRadio(): string | null {
__ea_trace("modules/usage/usage.ts","validateRadio",[],[]);
    const radioButtons = qa('[name="myInfoRadio"]')

    for (let i = 0; i < radioButtons.length; i++) {
      if ((radioButtons[i] as HTMLInputElement).checked) {
        selectRadioValue = (radioButtons[i] as HTMLInputElement).value
        isChecked = true
        break
      }
    }

    if (!isChecked) {
      q("#radioNull-error-message").innerHTML = "Please select an option."
      return "error"
    } else {
      q("#radioNull-error-message").innerHTML = ""
      return null
    }
  }
  void validateRadio

  function validateUsername(): string | null {
__ea_trace("modules/usage/usage.ts","validateUsername",[],[]);
    q("#verification-error-message").innerHTML = ""
    const email = qi("#UtilityUsername").value.trim()

    if (email === "") {
      q("#username_error_message").innerHTML = "Please enter your UserName."
      return "error"
    } else {
      q("#username_error_message").innerHTML = ""
      return null
    }
  }
  function validatePassword(): string | null {
__ea_trace("modules/usage/usage.ts","validatePassword",[],[]);
    q("#verification-error-message").innerHTML = ""
    const password = qi("#UtilityPassword").value.trim()
    globPass = password
    if (password === "") {
      q("#password_error_message").innerHTML = "Please enter a password."
      return "error"
    } else {
      q("#password_error_message").innerHTML = ""
      return null
    }
  }
  async function validateUtility(): Promise<boolean | undefined> {
__ea_trace("modules/usage/usage.ts","validateUtility",[],[]);
    const ErrorValidationList = [validateUsername(), validatePassword()]
    if (ErrorValidationList.includes("error")) {
      return false
    }
    // const endpoint = "https://hansen.danmarcrm.com/utilityValidationHansen.php";
    // EXTERNAL Hansen utility-validation service — no __ENV__ key exists, kept as literal.
    const endpoint = "http://hansen.danmarcrm.com/utilityValidationHansen_v1.php"

    const utilityId = storage.get("utility_id")
    void utilityId
    const requestBody = {
      utilityName: storage.get("utility_id"),
      utilityUsername: qi("#UtilityUsername").value.trim(),
      utilityPassword: qi("#UtilityPassword").value.trim(),
    }
    pageFoundOpenLoader()
    let catchdata: any = ""
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      })
      catchdata = requestBody
      if (!response.ok) {
        const errorResponseData = await response.json()
        const errorMessage = errorResponseData.Messages[0]
        pageFoundCloseLoader()
        q("#verification-error-message").innerHTML = errorMessage
        return
      }

      const responseData = await response.json()
      responseFromAPI = JSON.stringify(responseData)
      const searchString = "<MSG>Multiple Accounts Detected </MSG>"
      if (responseData.QualifiedFlag === "QUALIFIED") {
        const st = storage.get("FarmStateAbbreviation")
        if (st === "CO") {
          removeFormFields()
          await updateCredentialInDealRecord()
          q("#verified-message").innerHTML = "We have validated your user credentials."
          verifyidenty = "yes"
          pageFoundCloseLoader()
          q("#SkipThisFornNow").style.display = "none"
        } else {
          const accountNumber = responseData.Enrollment.find(
            (field: any) => field.FieldName === "Account Number",
          ).FieldValue
          const accountNumbersHansen: any[] = []
          accountNumbersHansen.push(accountNumber)
          enrollmentSessionID = responseData.EnrollmentSessionID
          removeFormFields()
          await updateCredentialInDealRecord()
          if (accountNumber != null && accountNumber !== undefined && accountNumber !== "") {
            await findmultiAccountNumberHansen(accountNumbersHansen)
            verifyidenty = "yes"
          } else {
            // alert('Account number did not found');
            verifyidenty = "yes"
          }
          q("#verified-message").innerHTML = "We have validated your user credentials."
          // verifyidenty = 'yes';
          pageFoundCloseLoader()
          q("#SkipThisFornNow").style.display = "none"
        }
      } else if (
        responseData.Messages &&
        Array.isArray(responseData.Messages) &&
        responseData.Messages.some((message: any) => message.includes(searchString))
      ) {
        const st = storage.get("FarmStateAbbreviation")
        if (st === "CO") {
          removeFormFields()
          await updateCredentialInDealRecord()
          q("#verified-message").innerHTML = "We have validated your user credentials."
          verifyidenty = "yes"
          pageFoundCloseLoader()
          q("#SkipThisFornNow").style.display = "none"
        } else {
          const xmlString = responseData.Messages[1]
          const accountNumbersHansen: any[] = []
          const regexHansen = /<ACCOUNTNUM>(\d+)<\/ACCOUNTNUM>/g
          let match: any
          while ((match = regexHansen.exec(xmlString)) !== null) {
            accountNumbersHansen.push(match[1])
          }
          removeFormFields()
          await updateCredentialInDealRecord()
          await findmultiAccountNumberHansen(accountNumbersHansen)
          q("#verified-message").innerHTML = "We have validated your user credentials."
          verifyidenty = "yes"
          pageFoundCloseLoader()
          q("#SkipThisFornNow").style.display = "none"
        }
      } else {
        const errorText = responseData.HttpCode + ", " + responseData.Status + ", " + responseData.Messages
        pageFoundCloseLoader()
        verifyidenty = "no"
        q("#verification-error-message").innerHTML = "Your Username and Password were not verified."
        q("#SkipThisFornNow").style.display = "block"
        const dealId = storage.get("dealId")
        try {
          const data = {
            properties: {
              deal_id: dealId,
              credential_validation_error_message: errorText,
            },
          }
          const response = await fetch(apiUrl("UpdateDealRecord"), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          })

          if (response.ok) {
            // (original left this branch empty)
          }
          const result = await response.json()
        } catch (error) {
          pageFoundCloseLoader()
          // alert('Server error. Please try again');
          console.error("Error:", error)
        }
      }
      if (response.status === 500 || response.status === 404) {
        verifyidenty = "no"
        q("#verification-error-message").innerHTML =
          'We are unable to connect to the utility and verify your credentials at this time. Please use the "Skip" option for now and we will send you a link to provide your credential later.'
        q("#SkipThisFornNow").style.display = "block"
        pageFoundCloseLoader()
      }
    } catch (error) {
      pageFoundCloseLoader()
      verifyidenty = "no"
      q("#verification-error-message").innerHTML =
        'We are unable to connect to the utility and verify your credentials at this time. Please use the "Skip" option for now and we will send you a link to provide your credential later.'
      q("#SkipThisFornNow").style.display = "block"
      console.error("Error:", error)
    }
  }
  function removeFormFields(): void {
__ea_trace("modules/usage/usage.ts","removeFormFields",[],[]);
    q("#UtilityUsername").style.display = "none"
    q("#username_error_message").style.display = "none"
    q("#UtilityPassword").style.display = "none"
    q("#togglePassword").style.display = "none"
    q("#password_error_message").style.display = "none"
    q("#SkipThisFornNow").style.display = "none"
    q("#verify").style.display = "none"
    q("#change").style.display = "block"
  }
  function showHiddenFields(): void {
__ea_trace("modules/usage/usage.ts","showHiddenFields",[],[]);
    if (q(".accountNumbersMainDiv") != null) {
      q(".accountNumbersMainDiv").remove()
    }
    q("#change").style.display = "none"
    q("#verified-message").innerHTML = "Your credentials have been removed. Please try again."
    q("#UtilityUsername").style.marginBottom = "25px"
    q("#UtilityUsername").style.display = "block"
    q("#username_error_message").style.display = "block"
    q("#UtilityPassword").style.display = "block"
    q("#togglePassword").style.display = "block"
    q("#password_error_message").style.display = "block"
    // q('#SkipThisFornNow').style.display = 'block';
    q("#verify").style.display = "block"
  }
  async function updateCredentialInDealRecord(): Promise<boolean> {
__ea_trace("modules/usage/usage.ts","updateCredentialInDealRecord",[],[]);
    const iHaveOnlineAccount = qi("#iHaveOnlineAccount")
    const skipThisForNowAndGetInTouch = qi("#skipThisForNowAndGetInTouch")
    void skipThisForNowAndGetInTouch
    let UtilityPassword: any
    const UtilityUsername = qi("#UtilityUsername").value.trim()
    if (iHaveOnlineAccount.checked) {
      if (globPass) {
        UtilityPassword = crypt.encrypt(globPass)
      }
    }
    const dealId = storage.get("dealId")
    let catchdata: any = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          utility_username: UtilityUsername,
          utility_password: UtilityPassword,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
        // (original left this branch empty)
      }
      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      pageFoundCloseLoader()
      // alert('Server error. Please try again');
      console.error("Error:", error)
    }
    return true
  }
  async function madeCredentialEmptyInDealRecord(): Promise<boolean> {
__ea_trace("modules/usage/usage.ts","madeCredentialEmptyInDealRecord",[],[]);
    const dealId = storage.get("dealId")
    let catchdata: any = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          utility_username: "",
          utility_password: "",
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
        pageFoundCloseLoader()
      }
      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      pageFoundCloseLoader()
      // alert('Server error. Please try again');
      console.error("Error:", error)
    }
    return true
  }
  async function findsingleAccountNumberHansen(accountNumbersHansen: any): Promise<void> {
__ea_trace("modules/usage/usage.ts","findsingleAccountNumberHansen",[accountNumbersHansen],["accountNumbersHansen"]);
    const property = "uan_1_value"
    const value = accountNumbersHansen
    const response = await fetch(apiUrl("SearchUANValuesInDealRecord"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ property, value }),
    })
    const data = await response.json()
    responseFromAPI = JSON.stringify(data)
    if (response.ok) {
      if (data.total === 0 || data.total === undefined) {
        firstId = accountNumbersHansen
        bayouAccountNo = firstId
        qi("#utilityAccountNo0").disabled = true
        qi("#utilityAccountNo0").value = firstId
      } else if (data.total === 1) {
        const dealIdFromDealFound = data.results[0].id
        const dealIdFromCurrentPage = storage.get("dealId")
        if (dealIdFromDealFound === dealIdFromCurrentPage) {
          firstId = accountNumbersHansen
          bayouAccountNo = firstId
          qi("#utilityAccountNo0").disabled = true
          qi("#utilityAccountNo0").value = firstId
        } else {
          qi("#utilityAccountNo0").disabled = false
          qi("#utilityAccountNo0").value = null as any
        }
      } else {
        qi("#utilityAccountNo0").disabled = false
        qi("#utilityAccountNo0").value = null as any
      }
    }
  }
  void findsingleAccountNumberHansen
  async function findmultiAccountNumberHansen(accountNumbersHansen: any): Promise<void> {
__ea_trace("modules/usage/usage.ts","findmultiAccountNumberHansen",[accountNumbersHansen],["accountNumbersHansen"]);
    // verifyidenty = 'no';
    const Accdiv = document.createElement("div")
    Accdiv.classList.add("accountNumbersMainDiv")
    const h2 = document.createElement("h2")
    h2.textContent = "Please select Account Number"
    Accdiv.appendChild(h2)
    const accul = document.createElement("ul")
    accul.classList.add("accountNumbersUl")
    for (const item of accountNumbersHansen) {
      const accli = document.createElement("li")
      const accspan = document.createElement("span")
      accli.classList.add(`acc${item}`)
      accspan.textContent = item
      accli.id = item
      accli.appendChild(accspan)
      const property = "uan_1_value"
      const value = item
      const response = await fetch(apiUrl("SearchUANValuesInDealRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ property, value }),
      })
      const data = await response.json()
      responseFromAPI = JSON.stringify(data)
      if (response.ok) {
        if (data.total === 0 || data.total === undefined) {
          // (original left this branch empty)
        } else if (data.total === 1) {
          const dealIdFromDealFound = data.results[0].id
          const dealIdFromCurrentPage = storage.get("dealId")
          if (dealIdFromDealFound === dealIdFromCurrentPage) {
            // (original left this branch empty)
          } else {
            accli.style.cursor = "not-allowed"
            accli.style.pointerEvents = "none"
            accli.style.color = "#999"
            accli.style.opacity = "0.5"
          }
        } else {
          accli.style.cursor = "not-allowed"
          accli.style.pointerEvents = "none"
          accli.style.color = "#999"
          accli.style.opacity = "0.5"
        }
      }
      accul.appendChild(accli)
      Accdiv.appendChild(accul)
      q(".have-online-details").appendChild(Accdiv)
    }

    function accountNumberSelected(event: any): void {
__ea_trace("modules/usage/usage.ts","accountNumberSelected",[event],["event"]);
      qa(".accountNumbersUl li span").forEach((span: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[span],["span"]);
        span.style.backgroundColor = "#ffffff"
      })

      const clickedElement = event.target
      firstId = clickedElement.parentElement.id
      bayouAccountNo = firstId

      clickedElement.style.backgroundColor = "#f18020"
      qa(".accountNumbersUl li span").forEach((span: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[span],["span"]);
        span.removeAttribute("data-selected")
      })
      clickedElement.setAttribute("data-selected", "true")
      qi("#utilityAccountNo0").disabled = true
      qi("#utilityAccountNo0").value = firstId
      verifyidenty = "yes"
    }
    qa(".accountNumbersUl li span").forEach((span: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[span],["span"]);
      span.addEventListener("click", accountNumberSelected)
    })
  }
  function fileFinalButtonValidation(): string | null {
__ea_trace("modules/usage/usage.ts","fileFinalButtonValidation",[],[]);
    if (listOfFiles == null || listOfFiles.length === 0) {
      q("#file-error-message").innerHTML = "No file selected. Please choose a file."
      return "error"
    } else {
      q("#file-error-message").innerHTML = ""
      return null
    }
  }

  // ─── add data in deal record ─────────────────────────────────────────────────
  async function addDataToDealRecord(fileUrl: any, skipUsage: any, globPass: any): Promise<boolean | undefined> {
__ea_trace("modules/usage/usage.ts","addDataToDealRecord",[fileUrl,skipUsage,globPass],["fileUrl","skipUsage","globPass"]);
    void globPass
    let fileurl1: any,
      fileurl2: any,
      fileurl3: any,
      fileurl4: any,
      fileurl5: any,
      fileurl6: any,
      fileurl7: any,
      fileurl8: any,
      fileurl9: any,
      fileurl10: any,
      fileurl11: any,
      fileurl12: any
    let uanLable1: any, uanLable2: any, uanLable3: any
    let uanValue1: any, uanValue2: any, uanValue3: any
    if (fileUrl[0]) {
      fileurl1 = fileUrl[0]
    } else {
      fileurl1 = ""
    }
    if (fileUrl[1]) {
      fileurl2 = fileUrl[1]
    } else {
      fileurl2 = ""
    }
    if (fileUrl[2]) {
      fileurl3 = fileUrl[2]
    } else {
      fileurl3 = ""
    }
    if (fileUrl[3]) {
      fileurl4 = fileUrl[3]
    } else {
      fileurl4 = ""
    }
    if (fileUrl[4]) {
      fileurl5 = fileUrl[4]
    } else {
      fileurl5 = ""
    }
    if (fileUrl[5]) {
      fileurl6 = fileUrl[5]
    } else {
      fileurl6 = ""
    }
    if (fileUrl[6]) {
      fileurl7 = fileUrl[6]
    } else {
      fileurl7 = ""
    }
    if (fileUrl[7]) {
      fileurl8 = fileUrl[7]
    } else {
      fileurl8 = ""
    }
    if (fileUrl[8]) {
      fileurl9 = fileUrl[8]
    } else {
      fileurl9 = ""
    }
    if (fileUrl[9]) {
      fileurl10 = fileUrl[9]
    } else {
      fileurl10 = ""
    }
    if (fileUrl[10]) {
      fileurl11 = fileUrl[10]
    } else {
      fileurl11 = ""
    }
    if (fileUrl[11]) {
      fileurl12 = fileUrl[11]
    } else {
      fileurl12 = ""
    }
    let isUANrow0Display = true
    let isUANrow1Display = true

    if (uanFieldDisplayarray[0] === "Yes") {
      if (uanAllLabels[0]) {
        uanLable1 = uanAllLabels[0]
      } else {
        uanLable1 = ""
      }
      uanValue1 = allAccountNumbers[0]
    } else if (uanFieldDisplayarray[0] === "No") {
      isUANrow0Display = false
      if (uanFieldIntDesArray[0]) {
        uanLable1 = uanFieldIntDesArray[0]
      } else {
        uanLable1 = ""
      }

      if (uanFieldDefault[0]) {
        uanValue1 = uanFieldDefault[0]
      } else {
        uanValue1 = ""
      }
    }

    if (uanFieldDisplayarray[1] === "Yes") {
      if (uanAllLabels[1]) {
        uanLable2 = uanAllLabels[1]
      } else {
        uanLable2 = ""
      }
      if (isUANrow0Display === true) {
        uanValue2 = allAccountNumbers[1]
      } else {
        uanValue2 = allAccountNumbers[0]
      }
    } else if (uanFieldDisplayarray[1] === "No") {
      isUANrow1Display = false
      if (uanFieldIntDesArray[1]) {
        uanLable2 = uanFieldIntDesArray[1]
      } else {
        uanLable2 = ""
      }
      if (uanFieldDefault[1]) {
        uanValue2 = uanFieldDefault[1]
      } else {
        uanValue2 = ""
      }
    }

    if (uanFieldDisplayarray[2] === "Yes") {
      if (uanAllLabels[2]) {
        uanLable3 = uanAllLabels[2]
      } else {
        uanLable3 = ""
      }
      if (isUANrow0Display === true && isUANrow1Display === true) {
        uanValue3 = allAccountNumbers[2]
      } else if (isUANrow0Display === false && isUANrow1Display === false) {
        uanValue3 = allAccountNumbers[0]
      } else if (isUANrow0Display === true && isUANrow1Display === false) {
        uanValue3 = allAccountNumbers[1]
      } else if (isUANrow0Display === false && isUANrow1Display === true) {
        uanValue3 = allAccountNumbers[1]
      }
    } else if (uanFieldDisplayarray[2] === "No") {
      if (uanFieldIntDesArray[2]) {
        uanLable3 = uanFieldIntDesArray[2]
      } else {
        uanLable3 = ""
      }
      if (uanFieldDefault[2]) {
        uanValue3 = uanFieldDefault[2]
      } else {
        uanValue3 = ""
      }
    }

    let UtilityPassword: any
    let UtilityUsername = qi("#UtilityUsername").value.trim()
    // var UtilityPassword = document.getElementById("UtilityPassword").value.trim();
    // var utilityAccountNo = document.getElementById("utilityAccountNo").value.trim();
    // var utility_bill_file_1 = document.getElementById("utility_bill_file_1").value.trim();
    const email = storage.get("userEmail")
    void email

    const iHaveOnlineAccountt = qi("#iHaveOnlineAccount")
    let iHaveOnlineAccount = "No"
    // var iDontHaveOnlineAcc = document.getElementById("iDontHaveOnlineAcc");
    const skipThisForNowAndGetInTouch = qi("#skipThisForNowAndGetInTouch")
    let skipUsageSubmission = "No"
    let credentialProvider = "None"
    if (iHaveOnlineAccountt.checked) {
      iHaveOnlineAccount = "Yes"
      credentialProvider = "Hansen"
      skipUsageSubmission = "No"
      if (globPass) {
        UtilityPassword = crypt.encrypt(globPass)
      }
    }

    if (skipThisForNowAndGetInTouch.checked) {
      iHaveOnlineAccount = "No"
      UtilityUsername = ""
      UtilityPassword = ""
      credentialProvider = "None"
      skipUsageSubmission = "Yes"
    }
    const dealId = storage.get("dealId")
    let concatenatedValue: any
    if (uanValue1 != null && uanValue1 !== "") {
      concatenatedValue = uanValue1
    }
    if (uanValue2 != null && uanValue2 !== "") {
      concatenatedValue += `-${uanValue2}`
    }
    if (uanValue3 != null && uanValue3 !== "") {
      concatenatedValue += `-${uanValue3}`
    }

    const property = "combined_utility_account_number"
    const value = concatenatedValue
    const response = await fetch(apiUrl("SearchUANValuesInDealRecord"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ property, value }),
    })

    const data = await response.json()
    responseFromAPI = JSON.stringify(data)
    if (response.ok) {
      if (data.total === 0 || data.total === undefined) {
        storage.rawSet("UanNumber", concatenatedValue)
        let catchdata: any = ""
        try {
          const data = {
            properties: {
              deal_id: dealId,
              utility_username: UtilityUsername,
              utility_password: UtilityPassword,
              // utility_account_number: utilityAccountNo,
              do_you_have_an_account_with_utility_service_provider: iHaveOnlineAccount,
              utility_bill_file_1_url: fileurl1,
              utility_bill_file_2_url: fileurl2,
              utility_bill_file_3_url: fileurl3,
              utility_bill_file_4_url: fileurl4,
              utility_bill_file_5_url: fileurl5,
              utility_bill_file_6_url: fileurl6,
              utility_bill_file_7_url: fileurl7,
              utility_bill_file_8_url: fileurl8,
              utility_bill_file_9_url: fileurl9,
              utility_bill_file_10_: fileurl10,
              utility_bill_file_11_: fileurl11,
              utility_bill_file_12_: fileurl12,
              credential_provider: credentialProvider,
              enrollmentsessionid: enrollmentSessionID,
              skip_usage_submission: skipUsageSubmission,
              uan_1_label: uanLable1,
              uan_1_value: uanValue1,
              uan_2_label: uanLable2,
              uan_2_value: uanValue2,
              uan_3_label: uanLable3,
              uan_3_value: uanValue3,
              // combined_utility_account_number: value,
            },
          }
          const response = await fetch(apiUrl("UpdateDealRecord"), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          })
          catchdata = data
          if (response.ok) {
            if (skipUsage != null) {
              storage.set("skipUsage", skipUsage)
            }
            checkConsentConfigurationVariation()
          }
          const result = await response.json()
          responseFromAPI = JSON.stringify(result)
        } catch (error) {
          pageFoundCloseLoader()
          // alert('Server error. Please try again');
          console.error("Error:", error)
        }
        return true
      } else if (data.total === 1) {
        const dealIdFromDealFound = data.results[0].id
        const dealIdFromCurrentPage = dealId
        if (dealIdFromDealFound === dealIdFromCurrentPage) {
          storage.rawSet("UanNumber", concatenatedValue)
          let catchdata: any = ""
          try {
            const data = {
              properties: {
                deal_id: dealId,
                utility_username: UtilityUsername,
                utility_password: UtilityPassword,
                // utility_account_number: utilityAccountNo,
                do_you_have_an_account_with_utility_service_provider: iHaveOnlineAccount,
                utility_bill_file_1_url: fileurl1,
                utility_bill_file_2_url: fileurl2,
                utility_bill_file_3_url: fileurl3,
                utility_bill_file_4_url: fileurl4,
                utility_bill_file_5_url: fileurl5,
                utility_bill_file_6_url: fileurl6,
                utility_bill_file_7_url: fileurl7,
                utility_bill_file_8_url: fileurl8,
                utility_bill_file_9_url: fileurl9,
                utility_bill_file_10_: fileurl10,
                utility_bill_file_11_: fileurl11,
                utility_bill_file_12_: fileurl12,
                credential_provider: credentialProvider,
                enrollmentsessionid: enrollmentSessionID,
                skip_usage_submission: skipUsageSubmission,
                uan_1_label: uanLable1,
                uan_1_value: uanValue1,
                uan_2_label: uanLable2,
                uan_2_value: uanValue2,
                uan_3_label: uanLable3,
                uan_3_value: uanValue3,
                // combined_utility_account_number: value,
              },
            }
            const response = await fetch(apiUrl("UpdateDealRecord"), {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(data),
            })
            catchdata = data
            if (response.ok) {
              if (skipUsage != null) {
                storage.set("skipUsage", skipUsage)
              }
              checkConsentConfigurationVariation()
            }
            const result = await response.json()
            responseFromAPI = JSON.stringify(result)
          } catch (error) {
            pageFoundCloseLoader()
            // alert('Server error. Please try again');
            console.error("Error:", error)
          }
          return true
        } else {
          q("#accounterror").innerHTML = "Account number already exists. Please try again."
          const section = q("#accounterror")
          if (section) {
            section.scrollIntoView({ behavior: "smooth" })
          }
          pageFoundCloseLoader()
          return false
        }
      } else {
        q("#accounterror").innerHTML = "Account number already exists. Please try again."
        const section = q("#accounterror")
        if (section) {
          section.scrollIntoView({ behavior: "smooth" })
        }
        pageFoundCloseLoader()
        return false
      }
      // Process and display the data as needed
    }
  }

  // ─── Save my place and remind me ─────────────────────────────────────────────
  async function saveDataToDealRecord(fileUrl?: any): Promise<boolean> {
__ea_trace("modules/usage/usage.ts","saveDataToDealRecord",[fileUrl],["fileUrl"]);
    const UtilityUsername = qi("#UtilityUsername").value.trim()
    let UtilityPassword: any = qi("#UtilityPassword").value.trim()
    // NOTE: bare `#utilityAccountNo` never exists (only indexed variants) — this
    // read throws on the live save-remind path; preserved.
    const utilityAccountNo = qi("#utilityAccountNo").value.trim()
    // var utility_bill_file_1 = document.getElementById("utility_bill_file_1").value.trim();
    const email = storage.get("userEmail")
    void email
    const iHaveOnlineAccount0 = qi("#iHaveOnlineAccount")
    // var iDontHaveOnlineAcc = document.getElementById("iDontHaveOnlineAcc");
    let iHaveOnlineAccount: any = iHaveOnlineAccount0
    let credentialProvider = ""
    if (fileUrl === "") {
      fileUrl = ""
    }
    if (iHaveOnlineAccount0.checked) {
      iHaveOnlineAccount = "Yes"
      credentialProvider = "Hansen"
      if (UtilityPassword) {
        UtilityPassword = crypt.encrypt(UtilityPassword)
      }
    } else {
      iHaveOnlineAccount = "No"
      // UtilityUsername = ''; // (kept commented — original re-assigned via let)
      UtilityPassword = ""
      credentialProvider = "None"
    }
    const dealId = storage.get("dealId")
    let catchdata: any = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          utility_username: UtilityUsername,
          utility_password: UtilityPassword,
          utility_account_number: utilityAccountNo,
          do_you_have_an_account_with_utility_service_provider: iHaveOnlineAccount,
          utility_bill_file_1_url: fileUrl,
          credential_provider: credentialProvider,
          enrollmentsessionid: enrollmentSessionID,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
      }
      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }

  // ─── utility name + logo from session config table ───────────────────────────
  function getDataFromSessionConfigTable(utilityIdd: any): void {
__ea_trace("modules/usage/usage.ts","getDataFromSessionConfigTable",[utilityIdd],["utilityIdd"]);
    // live site table id - 15223637
    const hubDBEndpoint = hubdbRowsUrl("utilityAvailability", {
      limit: limit,
      offset: offset,
    })
    fetch(hubDBEndpoint, { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/usage/usage.ts","(anon)",[data],["data"]);
        const matchingRows = data.objects.filter((row: any) => row.values[1] === utilityIdd)
        const rows = data.objects
        if (matchingRows.length >= 1) {
          allRows = allRows.concat(matchingRows)
        }
        if (rows.length === limit) {
          // There might be more rows, fetch the next page
          offset += limit
          return getDataFromSessionConfigTable(utilityIdd)
        }

        const utilityName = allRows[0].values[5]
        const utilityLogoImage = allRows[0].values[17].url
        const forgetPw = allRows[0].values[27]
        const forgetUs = allRows[0].values[28]
        const CreateAnAccBtn = allRows[0].values[29]
        const utiNameItem = root.getElementsByClassName("utilityName")
        const forgetPwitem = q("#forgetPw") as HTMLAnchorElement
        const forgetUsitem = q("#forgetUs") as HTMLAnchorElement
        const createAnAccountItem = q("#createAnAccount") as HTMLAnchorElement
        // --------------------------------
        if (utilityName !== undefined && utilityName !== "undefined") {
          if (utiNameItem.length > 0) {
            for (let i = 0; i < utiNameItem.length; i++) {
              ;(utiNameItem[i] as HTMLElement).innerText = utilityName
            }
          }
        }
        // --------------------------------
        if (utilityLogoImage !== undefined) {
          ;(q("#utilityLogoImage") as HTMLImageElement).src = utilityLogoImage
          q("#utilityName").innerText = ""
        } else {
          q("#utilityName").innerText = utilityName
          // NOTE: `getElementsById` is a typo (no such method) — throws if reached;
          // preserved via cast (unreachable unless the logo url is undefined).
          ;(document as any).getElementsById("utilityLogoImage").src = ""
        }
        // --------------------------------
        if (forgetPw.startsWith("https://")) {
          forgetPwitem.href = forgetPw
        } else if (forgetPw.startsWith("http://")) {
          forgetPwitem.href = forgetPw
        } else {
          forgetPwitem.href = `https://${forgetPw}`
        }
        // --------------------------------
        if (forgetUs.startsWith("https://")) {
          forgetUsitem.href = forgetUs
        } else if (forgetUs.startsWith("http://")) {
          forgetUsitem.href = forgetUs
        } else {
          forgetUsitem.href = `https://${forgetUs}`
        }
        // --------------------------------
        if (CreateAnAccBtn.startsWith("https://")) {
          createAnAccountItem.href = CreateAnAccBtn
        } else if (CreateAnAccBtn.startsWith("http://")) {
          createAnAccountItem.href = CreateAnAccBtn
        } else {
          createAnAccountItem.href = `https://${CreateAnAccBtn}`
        }
      })
      .catch(() => {
__ea_trace("modules/usage/usage.ts","(anon)",[],[]);
        // console.error('Error fetching data from HubDB:', error);
      })
  }

  function toggleContent(radioValue: any): void {
__ea_trace("modules/usage/usage.ts","toggleContent",[radioValue],["radioValue"]);
    const haveOnlineAccountRadio = q("#have-online-details")
    // var dontHaveOnlineAccountRadio = document.getElementById("iDoNotHaveOnlineAccitems");
    q("#radioNull-error-message").innerHTML = ""
    if (radioValue.value === "haveOnline") {
      haveOnlineAccountRadio.style.display = "block"
      // dontHaveOnlineAccountRadio.style.display = "none";
    } else {
      haveOnlineAccountRadio.style.display = "none"
      // dontHaveOnlineAccountRadio.style.display = "none";
    }
    // Toggle visibility based on the selected radio button's value
  }
  function captureFromCamera(): void {
__ea_trace("modules/usage/usage.ts","captureFromCamera",[],[]);
    const inputElement = document.createElement("input")
    inputElement.type = "file"
    inputElement.accept = "image/*"
    inputElement.addEventListener("change", function (this: HTMLInputElement) {
__ea_trace("modules/usage/usage.ts","(anon)",[this],["this"]);
      handleFilesNew(this.files)
    })

    inputElement.click()
  }
  void captureFromCamera
  function triggerFileInput(event: any): void {
__ea_trace("modules/usage/usage.ts","triggerFileInput",[event],["event"]);
    event.preventDefault()
    q('#mobileCamera input[type="file"]').click()
  }
  function dragOverHandler(event: any): void {
__ea_trace("modules/usage/usage.ts","dragOverHandler",[event],["event"]);
    event.preventDefault()
    q("#dropArea").classList.add("active")
  }
  function dropHandler(event: any): void {
__ea_trace("modules/usage/usage.ts","dropHandler",[event],["event"]);
    event.preventDefault()
    q("#dropArea").classList.remove("active")

    const files = event.dataTransfer.files
    q("#file-error-message").innerHTML = ""
    if (files.length > 0) {
      handleFilesNew(files)
    }
  }
  function browseFiles(): void {
__ea_trace("modules/usage/usage.ts","browseFiles",[],[]);
    const inputElement = document.createElement("input")
    q("#file-error-message").innerHTML = ""

    inputElement.type = "file"
    inputElement.accept = "application/pdf, image/*, image/heic, image/bmp, image/webp"
    inputElement.multiple = true
    inputElement.addEventListener("change", (event: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[event],["event"]);
      handleFilesNew(event.target.files)
    })
    inputElement.click()
  }
  void browseFiles

  // var file;
  function handleFilesNew(files: any): void {
__ea_trace("modules/usage/usage.ts","handleFilesNew",[files],["files"]);
    const maxFiles = 12
    let totalfilecount = 0
    totalfilecount = listOfFiles.length + files.length

    if (files.length > 0 && totalfilecount <= maxFiles) {
      const allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/heic", "image/bmp", "image/webp"]
      const totalSize = 0
      void totalSize

      let file: any
      for (let i = 0; i < files.length; i++) {
        file = files[i]

        if (!allowedTypes.includes(file.type)) {
          q("#file-error-message").innerHTML =
            "Invalid file type. Please choose valid PDF, PNG, JPEG, HEIC, BMP, or WebP files."
          return
        }
      }

      if (file.size > 10 * 1024 * 1024) {
        q("#file-error-message").innerHTML =
          `The total size of selected files exceeds the limit. Please choose files up to 10 MB in total.`
        return
      }

      const fileNameDisplay = q("#fileNameDisplay")
      const previewContainer = q("#previewContainer")

      for (let j = 0; j < files.length; j++) {
        const file2 = files[j]
        const reader = new FileReader()
        const preview = document.createElement("div")
        preview.className = "swiper-slide"
        preview.innerHTML = `<img src="" alt="Preview Image" width="100%" height="auto" id="imageNo${j}">`
        previewContainer.appendChild(preview)

        reader.onload = ((preview: any, file: any) => (e: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[e],["e"]);
          if (file.type === "application/pdf") {
            pdfjsLib.getDocument(e.target.result).promise.then((pdf: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[pdf],["pdf"]);
              pdf.getPage(1).then((page: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[page],["page"]);
                const canvas = document.createElement("canvas")
                const context = canvas.getContext("2d")
                const viewport = page.getViewport({ scale: 1.5 })
                canvas.height = viewport.height
                canvas.width = viewport.width
                const renderContext = {
                  canvasContext: context,
                  viewport: viewport,
                }
                page.render(renderContext).promise.then(() => {
__ea_trace("modules/usage/usage.ts","(anon)",[],[]);
                  ;(preview.querySelector("img") as HTMLImageElement).src = canvas.toDataURL("image/jpeg")
                })
              })
            })
          } else {
            ;(preview.querySelector("img") as HTMLImageElement).src = e.target.result
          }

          const blobUrl = URL.createObjectURL(file)
          void blobUrl
          // Add an event listener to open the image in a new tab when clicked
          initSwiper() // Initialize Swiper after adding each image
        })(preview, file2)

        reader.readAsDataURL(file2)
        listOfFiles.push(file2)
      }

      fileNameDisplay.textContent = `File Name: ${listOfFiles.map((f: any) => f.name).join(", ")}`
      q("#fileCount").textContent = `Total files selected: ${listOfFiles.length}`
    } else {
      q("#file-error-message").innerHTML = `Please select between 1 and ${maxFiles} files.`
    }
  }
  function initSwiper(): void {
__ea_trace("modules/usage/usage.ts","initSwiper",[],[]);
    swiper = new Swiper(".swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
    q(".swiper-button-next").innerHTML = "<span>Next</span>"
    q(".swiper-button-prev").innerHTML = "<span>Previous</span>"
  }
  function removeCurrentImage(): void {
__ea_trace("modules/usage/usage.ts","removeCurrentImage",[],[]);
    // q('.swiper-slide.swiper-slide-active').remove;
    const activeIndex = swiper.activeIndex
    q("#file-error-message").innerHTML = ""

    listOfFiles.splice(activeIndex, 1) // Remove the file from the list
    swiper.removeSlide(activeIndex) // Remove the slide from Swiper
    q("#fileCount").textContent = `Total files selected: ${listOfFiles.length}`

    initSwiper() // Reinitialize Swiper

    const fileNameDisplay = q("#fileNameDisplay")
    fileNameDisplay.textContent = `File Name: ${listOfFiles.map((f: any) => f.name).join(", ")}`

    q(".RemoveFilePopup").style.display = "none"
  }
  function removeImageOpenPopup(): void {
__ea_trace("modules/usage/usage.ts","removeImageOpenPopup",[],[]);
    q(".RemoveFilePopup").style.display = "block"
  }
  function removeImageClosePopup(): void {
__ea_trace("modules/usage/usage.ts","removeImageClosePopup",[],[]);
    q(".RemoveFilePopup").style.display = "none"
  }

  // ─── upload file to file manager and return file url ──────────────────────────
  async function uploadFileToServer(): Promise<any[]> {
__ea_trace("modules/usage/usage.ts","uploadFileToServer",[],[]);
    clearDatabase()

    // Use the global variable listOfFiles to send files in the API call
    const uploadedUrls: any[] = [] // Array to store uploaded URLs
    for (const file of listOfFiles) {
      try {
        const formData = new FormData()
        const originalName = file.name

        const safeName = originalName
          .replace(/[\u0000-\u001F\u007F-\u009F]/g, "")
          .replace(/[^\x00-\x7F]/g, "")
          .replace(/\s+/g, " ")

        formData.append("file", file, safeName)
        formData.append("name", safeName)

        const requestOptions = {
          method: "POST",
          body: formData,
        }

        // Make the API call
        // EXTERNAL AWS file-manager upload service — no __ENV__ key exists, kept as literal.
        const response = await fetch("https://aws.nautilussolar.com/testRoute/uploadFileToFileManager", requestOptions)
        // https://aws.nautilussolar.com:5000/testRoute/uploadFileToFileManager
        // https://nidish.us:5000/testRoute/uploadFileToFileManager
        const result = await response.json()
        responseFromAPI = JSON.stringify(result)
        if (response.ok) {
          saveFileToIndexedDB(file)
          uploadedUrls.push(result.response.url)
        } else {
          throw new Error("Error uploading file")
        }
      } catch (error) {
        throw error // Throw the error to be caught by the calling code
      }
    }
    return uploadedUrls
  }

  // ─── update Deal Stage ────────────────────────────────────────────────────────
  async function updateDealStage(value: any): Promise<boolean> {
__ea_trace("modules/usage/usage.ts","updateDealStage",[value],["value"]);
    await delay(2000)
    const dealId = storage.get("dealId")
    let catchdata: any = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          dealstage: value,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
        // alert('Deal Stage Updated');
      }

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }

  async function delay(ms: number): Promise<void> {
__ea_trace("modules/usage/usage.ts","delay",[ms],["ms"]);
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  async function checkConsentConfigurationVariation(): Promise<void> {
__ea_trace("modules/usage/usage.ts","checkConsentConfigurationVariation",[],[]);
    let consetPaymentReq: any
    const SessionLocalStorage = JSON.parse(storage.get("UtilitySessionDetails") ?? "null")
    if (SessionLocalStorage["33"] === 0) {
      consetPaymentReq = "No"
    } else if (SessionLocalStorage["33"] === 1) {
      consetPaymentReq = "Yes"
    } else {
      consetPaymentReq = "No"
    }
    const consentDisplayelementList = JSON.parse(storage.get("consentDisplayelementList") ?? "null")
    if (consentDisplayelementList != null) {
      if (consentDisplayelementList.length > 0) {
        if (consetPaymentReq === "Yes") {
          await updateDealStage("127892568")
          storage.rawSet("rp", "QxtVq")
          pageFoundCloseLoader()
          window.location.href = "/my-consent"
        } else {
          await updateDealStage("127892567")
          storage.rawSet("rp", "NpEv")
          pageFoundCloseLoader()
          window.location.href = "/my-consent"
        }
      }
    }
  }

  // ─── IndexedDB ──────────────────────────────────────────────────────────────
  function saveFileToIndexedDB(file: any): void {
__ea_trace("modules/usage/usage.ts","saveFileToIndexedDB",[file],["file"]);
    const reader = new FileReader()

    reader.onload = (event: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[event],["event"]);
      const arrayBuffer = event.target.result
      // Create an object to store both the file name and the ArrayBuffer
      const fileObject = {
        name: file.name,
        type: file.type,
        data: arrayBuffer,
      }
      const transaction = db.transaction(["files"], "readwrite")
      const objectStore = transaction.objectStore("files")

      // Save the ArrayBuffer in the object store
      const request = objectStore.put(fileObject)

      request.onerror = (event: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[event],["event"]);
        console.log(`Database error: ${(event.target as any).errorCode}`)
      }
    }

    reader.onerror = (event: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[event],["event"]);
      console.error("Error reading file:", event.target.error)
    }

    // Read the file as ArrayBuffer
    reader.readAsArrayBuffer(file)
  }

  function getAllFilesFromIndexedDB(): void {
__ea_trace("modules/usage/usage.ts","getAllFilesFromIndexedDB",[],[]);
    const transaction = db.transaction(["files"], "readonly")
    const objectStore = transaction.objectStore("files")
    const filess: any[] = []
    let index = 0

    // Open a cursor to iterate over all objects in the object store
    objectStore.openCursor().onsuccess = (event: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[event],["event"]);
      const cursor = event.target.result
      if (cursor) {
        const fileName = cursor.value.name
        const blobData = cursor.value.data
        const fileType = cursor.value.type
        const file = new File([blobData], fileName, { type: fileType })
        index++
        filess.push(file)
        cursor.continue()
      } else {
        // All files have been retrieved
        if (index !== 0) {
          handleFilesNew(filess)
        }
      }
    }
  }
  // Function to clear the entire IndexedDB database
  function clearDatabase(): void {
__ea_trace("modules/usage/usage.ts","clearDatabase",[],[]);
    const transaction = db.transaction(db.objectStoreNames, "readwrite")

    transaction.oncomplete = () => {
__ea_trace("modules/usage/usage.ts","(anon)",[],[]);
    }

    transaction.onerror = (event: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[event],["event"]);
    }

    Array.from(db.objectStoreNames).forEach((storeName: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[storeName],["storeName"]);
      const objectStore = transaction.objectStore(storeName)
      objectStore.clear()
    })
  }
  // End of IndexedDB

  // ─── Wiring (was top-level in the inline script) ──────────────────────────────
  pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.11.338/pdf.worker.min.js"

  // Go back personal information button (cross-widget sibling, kept document-scoped).
  dq(".page1lmileftright_myusage #goback-personal-info").addEventListener("click", () => {
__ea_trace("modules/usage/usage.ts","(anon)",[],[]);
    window.location.href = "/my-info"
  })

  getEmail()

  q("#fileInput").addEventListener("change", (event: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files)
  })

  ShowHide()

  getDataFromUANConfigTable(utilityIdd)

  qi("#UtilityUsername").addEventListener("input", validateUsername)
  qi("#UtilityPassword").addEventListener("input", validatePassword)
  // document.querySelectorAll(".utilityAccountNo").addEventListener("input", validateAccountNumber);

  q("#verify").addEventListener("click", validateUtility)
  q("#change").addEventListener("click", async () => {
__ea_trace("modules/usage/usage.ts","(anon)",[],[]);
    verifyidenty = "no"
    pageFoundOpenLoader()
    showHiddenFields()
    await madeCredentialEmptyInDealRecord()
  })

  // Get utility button click
  q("#get-utility-info").addEventListener("click", () => {
__ea_trace("modules/usage/usage.ts","(anon)",[],[]);
    pageFoundOpenLoader()
    if (stat === "NY") {
      const ErrorValidationList = [fileFinalButtonValidation(), getAccountNumberErrorifExist()]
      if (ErrorValidationList.includes("error")) {
        pageFoundCloseLoader()
        q("#finalCheck-error").innerHTML = "please fix the error before submitting"
      } else {
        q("#finalCheck-error").innerHTML = ""
        const iHaveOnlineAccount = qi("#iHaveOnlineAccount")
        void iHaveOnlineAccount
        const skipThisForNowAndGetInTouch = qi("#skipThisForNowAndGetInTouch")
        void skipThisForNowAndGetInTouch
        ;(async () => {
__ea_trace("modules/usage/usage.ts","(anon)",[],[]);
          try {
            const url = await uploadFileToServer()
            const skipUsage = "No"
            addDataToDealRecord(url, skipUsage, globPass)
          } catch (error) {
            pageFoundCloseLoader()
            alert(error)
            window.location.href = "/my-usage"
          }
        })()
      }
    } else {
      const ErrorValidationList = [validateHaveonline(), fileFinalButtonValidation(), getAccountNumberErrorifExist()]
      if (ErrorValidationList.includes("error")) {
        pageFoundCloseLoader()
        q("#finalCheck-error").innerHTML = "please fix the error before submitting"
      } else {
        q("#finalCheck-error").innerHTML = ""
        const iHaveOnlineAccount = qi("#iHaveOnlineAccount")
        // var iDontHaveOnlineAcc = document.getElementById("iDontHaveOnlineAcc");
        const skipThisForNowAndGetInTouch = qi("#skipThisForNowAndGetInTouch")
        if (iHaveOnlineAccount.checked) {
          if (verifyidenty === "yes") {
            ;(async () => {
__ea_trace("modules/usage/usage.ts","(anon)",[],[]);
              try {
                const url = await uploadFileToServer()
                const skipUsage = "No"
                addDataToDealRecord(url, skipUsage, globPass)
              } catch (error) {
                pageFoundCloseLoader()
                alert(error)
                window.location.href = "/my-usage"
              }
            })()
          } else if (verifyidenty === "no") {
            pageFoundCloseLoader()
            q("#verification-error-message").innerHTML = "Your Username and Password doesn't verified."
            q("#verified-message").innerHTML = ""
            const sectionId = "haveOnlineAccountMainDiv"
            const section = q(`#${sectionId}`)
            if (section) {
              section.scrollIntoView({ behavior: "smooth" })
            }
          } else if (verifyidenty === undefined) {
            pageFoundCloseLoader()
            q("#verification-error-message").innerHTML = "Please verify Username and Password before submit."
            q("#verified-message").innerHTML = ""
            const sectionId = "haveOnlineAccountMainDiv"
            const section = q(`#${sectionId}`)
            if (section) {
              section.scrollIntoView({ behavior: "smooth" })
            }
          }
        } else if (skipThisForNowAndGetInTouch.checked) {
          ;(async () => {
__ea_trace("modules/usage/usage.ts","(anon)",[],[]);
            try {
              const url = await uploadFileToServer()
              const skipUsage = "Yes"
              addDataToDealRecord(url, skipUsage, addDataToDealRecord)
            } catch (error) {
              pageFoundCloseLoader()
              alert(error)
              window.location.href = "/my-usage"
            }
          })()
        }
      }
    }
  })

  // Save my place and remind me
  q("#save-remind").addEventListener("click", () => {
__ea_trace("modules/usage/usage.ts","(anon)",[],[]);
    ;(async () => {
__ea_trace("modules/usage/usage.ts","(anon)",[],[]);
      try {
        const url = await uploadFileToServer()
        saveDataToDealRecord(url)
      } catch (error) {
        saveDataToDealRecord()
      }
    })()
  })

  getDataFromSessionConfigTable(utilityIdd)

  // checked skip radio if exist on page load
  const ms_currentUrl = window.location.href
  if (ms_currentUrl.includes("?Rftyp=")) {
    q("#SkipThisFornNow").style.display = "none"
    qi("#iHaveOnlineAccount").checked = true
    const ms_updatedUrl = ms_currentUrl.replace("?Rftyp=", "")
    window.history.replaceState({}, document.title, ms_updatedUrl)
    isWeBackFromTYP = true
    storage.rawSet("isWeBackFromTYP", "yes")
  } else {
    q("#SkipThisFornNow").style.display = "block"
    isWeBackFromTYP = false
  }
  const ls_isWeBackFromTYP = storage.rawGet("isWeBackFromTYP")
  if (ls_isWeBackFromTYP != null && ls_isWeBackFromTYP === "yes") {
    q("#SkipThisFornNow").style.display = "none"
    qi("#iHaveOnlineAccount").checked = true
  }

  q("#imageInput").addEventListener("change", (event: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[event],["event"]);
    const file = event.target.files[0]
    void file
    handleFilesNew(event.target.files)
  })

  // IndexedDB open
  const request = indexedDB.open("myDatabase", 1)

  request.onerror = (event) => {
__ea_trace("modules/usage/usage.ts","(anon)",[event],["event"]);
    console.log(`Database error: ${(event.target as any).errorCode}`)
  }

  request.onsuccess = (event: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[event],["event"]);
    db = event.target.result
    getAllFilesFromIndexedDB()
  }

  request.onupgradeneeded = (event: any) => {
__ea_trace("modules/usage/usage.ts","(anon)",[event],["event"]);
    const db = event.target.result

    // Create an object store (similar to a table in relational databases)
    const objectStore = db.createObjectStore("files", { autoIncrement: true })

    // Optionally, create indexes for efficient querying
    objectStore.createIndex("name", "name", { unique: false })
  }

  const togglePassworddd = q("#haveOnlineAccountMainDiv #togglePassword")
  const passworddd = qi("#haveOnlineAccountMainDiv #UtilityPassword")
  togglePassworddd.addEventListener("click", function (this: HTMLElement) {
__ea_trace("modules/usage/usage.ts","(anon)",[this],["this"]);
    // toggle the type attribute
    const type = passworddd.getAttribute("type") === "password" ? "text" : "password"
    passworddd.setAttribute("type", type)
    // toggle the icon
    this.classList.toggle("fa-eye-slash")
  })

  if (stat === "NY") {
    q("#haveOnlineAccountMainDiv").style.display = "none"
  }
  q("#SkipThisFornNow").style.display = "none"

  // ─── wire the (formerly inline) handlers ─────────────────────────────────────
  // The markup no longer carries onclick/ondrop/ondragover attributes; the former
  // inline handlers are bound here, root-scoped, so no page function leaks onto
  // window (matches the drag/drop bill-upload pattern in modules/savings-intro.ts).
  const bind = (sel: string, type: string, fn: (e: any) => void) => {
__ea_trace("modules/usage/usage.ts","bind",[sel,type,fn],["sel","type","fn"]);
    const el = root.querySelector(sel)
    if (el) el.addEventListener(type, fn)
  }

  // online-account radios → toggleContent(this)
  bind("#iHaveOnlineAccount", "click", (e) => toggleContent(e.currentTarget))
  bind("#skipThisForNowAndGetInTouch", "click", (e) => toggleContent(e.currentTarget))

  // bill-upload group
  bind("#dropArea", "drop", (e) => dropHandler(e))
  bind("#dropArea", "dragover", (e) => dragOverHandler(e))
  bind("#dropArea", "click", () => triggerFilePicker())
  bind("#mobileCamera img", "click", (e) => triggerFileInput(e))
  bind("#mobileCamera a", "click", (e) => triggerFileInput(e))
  bind(".uploadRemoveButtons button:not([id])", "click", () => triggerFilePicker())
  bind("#removeimagebutton", "click", () => removeImageOpenPopup())
  bind(".removefilePopButtons button:not([id])", "click", () => removeCurrentImage())
  bind("#keepIt", "click", () => removeImageClosePopup())

  GetDataFromDealRecord()
}
